/**
 * The character's active quests that lead to an atlas place (Tome UI Round 3, the next program's E2):
 * their objective maps while work is left, then the turn-in map, each on its atlas place (a pocket map
 * counts for its parent). Built from the journal's own entries, so a quest the character has not taken
 * never shows here.
 */
import type { QuestLog } from '../../../../shared/CharacterTypes';
import { journalEntries } from '../Quest/questJournalModel';
import { resolveMapPresentationId } from './worldMapModel';

export interface AtlasQuest { id: string; title: string; ready: boolean }

export function atlasQuestsAt(log: QuestLog, placeId: string): AtlasQuest[] {
  return journalEntries(log).active.flatMap((quest) => {
    const guidance = quest.definition?.guidance;
    if (!guidance) return [];
    const ready = quest.state === 'ready';
    const maps = [
      ...(ready ? [] : guidance.objectives.flatMap((o) => (o.location ? [o.location.mapId] : []))),
      guidance.turnIn.location.mapId,
    ];
    return maps.some((id) => resolveMapPresentationId(id) === placeId) ? [{ id: quest.id, title: quest.title, ready }] : [];
  });
}
